import { SectionsEnum } from '../enums/sections.enum';

export const RoutesDictionary: Record<SectionsEnum, string> = {
    [SectionsEnum.DATA_COLLECTION_FORMS]: 'data-collection/forms',
    [SectionsEnum.DATA_COLLECTION_INSPECTION]: 'data-collection/inspection',
    [SectionsEnum.DATA_COLLECTION_INSPECTIONS]: 'data-collection/inspections',
    [SectionsEnum.DATA_COLLECTION_SURVEYS]: 'data-collection/surveys',
};
